import arrowRight from './arrow-right.svg';
import caretDown from './caret-down.svg';
import customer from './customer.svg';
import customerEntry from './customer-entry.svg';
import group from './group.svg';

const icons = {
  arrowRight,
  caretDown,
  customer,
  customerEntry,
  group,
};

export default icons;
